/**
 * 活动管理
 */

import { AcivityDialogType, addEditDialog } from './_dialog'
import { PageContext } from '@zto/zpage'

// 查看活动
const detailAction = {
  label: '查看',
  dialog: addEditDialog(AcivityDialogType.VIEW)
}

export default {
  body: {
    type: 'crud',

    actions: {
      query: { api: 'admin/resource/queryList', params: { activityCode: '', id: 0 } },
      add: { api: 'admin/resource/saveOrUpdate', dialog: addEditDialog() },
      edit: { api: 'admin/resource/saveOrUpdate', dialog: addEditDialog(AcivityDialogType.EDIT) },
      detail: detailAction,
      close: {
        api: 'admin/resource/updateStatus',
        payload: { activityCode: '${data.row.activityCode}', activityStatus: 5 },
        message: '下架此此片区会造成所有瓷片无法显示, 确定是否下架？'
      },
      close2: {
        api: 'admin/resource/updateStatus',
        payload: { activityCode: '${data.row.activityCode}', activityStatus: 5 },
        message: '确定是否下架？'
      }
    },

    search: {
      items: [
        { label: '活动名称', type: 'input', prop: 'activityName' },
        { label: '活动位', type: 'select', prop: 'activityPlace', options: 'activityPlace' },
        { label: '活动状态', type: 'select', prop: 'activityStatus', options: 'activityStatusOpts' }
      ]
    },

    toolbar: {
      items: [{ action: 'add' }]
    },

    table: {
      operation: {
        width: 150,
        items: [
          { action: 'detail' },
          {
            action: 'edit',
            visibleOn: `this.data.row.activityStatus!==5`
          },
          {
            action: 'close',
            label: '下架',
            visibleOn: ({ data }: PageContext) => {
              return [0, 1].includes(data.row.activityStatus) && ['2', '3', '4'].includes(data.row.activityPlace)
            }
          },
          {
            action: 'close2',
            label: '下架',
            visibleOn: ({ data }: PageContext) => {
              return [0, 1].includes(data.row.activityStatus) && ['1', '5'].includes(data.row.activityPlace)
            }
          }
        ]
      },

      columns: [
        { label: '活动ID', prop: 'activityCode', minWidth: 250 },
        {
          label: '资源位',
          prop: 'activityPlace',
          formatter: { name: 'enumStr', options: 'activityPlace' },
          width: 120
        },
        { label: '活动名称', prop: 'activityName', width: 180 },
        { label: '开始时间', prop: 'startDate', formatter: 'date', width: 180 },
        { label: '结束时间', prop: 'endDate', formatter: 'date', width: 180 },
        { label: '活动状态', prop: 'activityStatusStr', width: 100 },
        { label: '操作人', prop: 'modifier', width: 100 }
      ]
    }
  }
}
